import Vue from 'vue'
import Vuex from 'vuex'
import boardInformation from './store/boardInformation'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    boardInformation
  },
  state: {
    borrow: {
      name: '',
      last_name: '',
      phone: '',
      email: '',
      amountBorrow: '',
      amountDate: '',
      loanType: 'Payday',
      borrower_photo: ''
    },
    borrowForm: {
      contact: {
        name: '',
        phoneNumber: '',
        nationalIdNumber: '',
        emailAddress: ''
      },
      personalInfo: {
        dateOfBirth: '',
        gender: '',
        address: '',
        howLongBeenLiving: ''
      },
      employmentDetail: {
        whyApplyForLoan: '',
        occupation: '',
        nameCompany: '',
        grossMonthlyIncome: '',
        companyContactName: '',
        telephoneNumber: ''
      },
      relativeInformation: {
        name: '',
        contact: '',
        thePersonIsYour: ''
      },
      bankDetail: {
        accountNumber: '',
        bankName: '',
        agreePostPublic: false,
        facebookName: ''
      }
    },
    investForm: {
      companyOrPerson: '',
      name: '',
      amountToInvest: '',
      contactNumber: '',
      noteAndComment: ''
    },
    defaultBorrowForm: {
      contact: {
        name: '',
        phoneNumber: '',
        nationalIdNumber: '',
        emailAddress: ''
      },
      personalInfo: {
        dateOfBirth: '',
        gender: '',
        address: '',
        howLongBeenLiving: ''
      },
      employmentDetail: {
        whyApplyForLoan: '',
        occupation: '',
        nameCompany: '',
        grossMonthlyIncome: '',
        companyContactName: '',
        telephoneNumber: ''
      },
      relativeInformation: {
        name: '',
        contact: '',
        thePersonIsYour: ''
      },
      bankDetail: {
        accountNumber: '',
        bankName: '',
        agreePostPublic: false,
        facebookName: ''
      }
    },
    defaultInvestForm: {
      companyOrPerson: '',
      name: '',
      amountToInvest: '',
      contactNumber: '',
      noteAndComment: ''
    },
    has_pending_loan: false,
    logged_in: false
  },
  mutations: {
    setDataBorrower (state, borrow) {
      if (borrow.name) {
        const name = borrow.name.replace(' ', '#$%^&').split('#$%^&')
        if (name.length === 2) {
          state.borrow.name = name[0]
          state.borrow.last_name = name[1]
        } else {
          state.borrow.name = name[0]
        }
      }
      state.borrow.phone = borrow.phone
      state.borrow.email = borrow.email
      state.borrow.loanType = borrow.loanType
    },
    resetStateBorrower (state) {
      state.borrow.name = ''
      state.borrow.last_name = ''
      state.borrow.phone = ''
      state.borrow.email = ''
      state.borrow.loanType = 'Payday'
      state.borrow.borrower_photo = ''
    },
    checkUserHasPendingLoan (state, hasPendingLoan) {
      state.has_pending_loan = hasPendingLoan
    },
    checkUserLogin (state, is_login) {
      state.logged_in = is_login
    },
    setAvatar (state, link_image) {
      state.borrow.borrower_photo = link_image
    },
    setAmountAndDuration (state, borrow) {
      state.borrow.amountBorrow = borrow.amount
      state.borrow.amountDate = borrow.duration
    },
    clearAmountAndDuration (state) {
      state.borrow.amountBorrow = ''
      state.borrow.amountDate = ''
    },
    setLoanType (state, loan_type) {
      if (loan_type) {
        state.borrow.loanType = loan_type
      } else {
        state.borrow.loanType = 'Payday'
      }
    }
  },
  actions: {
    setLoanType ({ commit, state }, loan_type) {
      commit('setLoanType', loan_type)
    },
    setDataBorrower ({ commit, state }, borrow) {
      commit('setDataBorrower', borrow)
    },
    resetStateBorrower ({ commit }) {
      commit('resetStateBorrower')
    },
    checkUserLogin ({ commit, state }, is_login) {
      commit('checkUserLogin', is_login)
    },
    checkUserHasPendingLoan ({ commit, state }, hasPendingLoan) {
      commit('checkUserHasPendingLoan', hasPendingLoan)
    },
    setAvatar ({ commit, state }, link_image) {
      commit('setAvatar', link_image)
    },
    setAmountAndDuration ({ commit, state }, borrow) {
      commit('setAmountAndDuration', borrow)
    },
    clearAmountAndDuration ({ commit }) {
      commit('clearAmountAndDuration')
    }
  }
})
